'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { HStack } from '@/components/Layout';
import { InnerNavigation } from './-components/InnerNavigation';
export const Route = createFileRoute('/_staff/idp/_layout/settings')({
  component: SettingsLayout
});
function SettingsLayout() {
  return <HStack className="items-start gap-10 px-12 py-6">
      <InnerNavigation />
      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
    </HStack>;
}